import validate from './utils/validate.js';

const HAS_WINDOWS = typeof window !== 'undefined';
const HAS_NAVIGATOR = typeof navigator !== 'undefined';
const IS_TOUCH = HAS_WINDOWS && (
    'ontouchstart' in window || (
        HAS_NAVIGATOR &&
        navigator.msMaxTouchPoints > 0
    )
);
const EVENT = IS_TOUCH ? 'touchstart' : 'click';

export default (() => {
    const listeners = new Map();

    const handler = event => {
        for (const [element, callback] of listeners.entries()) {
            const path = event.composedPath
                ? event.composedPath()
                : event.path;

            const isClickOutside = path
                ? path.indexOf(element) < 0
                : !element.contains(event.target);

            if (!isClickOutside) return;

            callback(event, element);
        }
    };

    return {
        created() {
            document.addEventListener(EVENT, handler, true);
        },

        beforeMount(el, binding) {
            if (!validate(binding)) return;

            listeners.set(el, binding.value);
        },

        updated(el, binding) {
            if (!validate(binding)) return;

            listeners.set(el, binding.value);
        },

        unmounted(el) {
            listeners.delete(el);
        },
    };
})();
